module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst data = rowResourceData || {}\nconst attributes = data.attributes || {}\nconst employee = attributes.employee || {}\nconst contractor = attributes.contractor || {}\nlet name = '-', icon = false\nif(employee.employeeID){\nconst employeeNameParts = []\nif(employee.title) employeeNameParts.push(employee.title);\nif(employee.firstname) employeeNameParts.push(employee.firstname);\nif(employee.lastname) employeeNameParts.push(employee.lastname);\nif(employee.nickname) employeeNameParts.push(`aka ${employee.nickname}`);\nname = employeeNameParts.join(' ')\nif(employee.type === 'internal'){\nicon = 'fi fi-employee-internal'\n} else if(employee.type === 'external'){\nicon = 'fi fi-employee-external'\n} else if(employee.type === 'occasional'){\nicon = 'fi fi-employee-occasional'\n}\n}\nif(contractor.contractorID){\nicon = 'fi fi-contractors'\nname = contractor.companyName\n}\n%><div title=\"<%= name %>\"><%\n%><label><%= name %></label><%\nif(icon){\n%><i class=\"<%= icon %>\"></i><%\n}\n%></div>"
  , __filename = "components/templates/office/projectTermJobs/tableFields/employee.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const data = rowResourceData || {}
const attributes = data.attributes || {}
const employee = attributes.employee || {}
const contractor = attributes.contractor || {}
let name = '-', icon = false
if(employee.employeeID){
const employeeNameParts = []
if(employee.title) employeeNameParts.push(employee.title);
if(employee.firstname) employeeNameParts.push(employee.firstname);
if(employee.lastname) employeeNameParts.push(employee.lastname);
if(employee.nickname) employeeNameParts.push(`aka ${employee.nickname}`);
name = employeeNameParts.join(' ')
if(employee.type === 'internal'){
icon = 'fi fi-employee-internal'
} else if(employee.type === 'external'){
icon = 'fi fi-employee-external'
} else if(employee.type === 'occasional'){
icon = 'fi fi-employee-occasional'
}
}
if(contractor.contractorID){
icon = 'fi fi-contractors'
name = contractor.companyName
}

    ; __line = 26
    ; __append("<div title=\"")
    ; __append(escapeFn( name ))
    ; __append("\">")
    ; 

    ; __line = 27
    ; __append("<label>")
    ; __append(escapeFn( name ))
    ; __append("</label>")
    ; 
if(icon){

    ; __line = 29
    ; __append("<i class=\"")
    ; __append(escapeFn( icon ))
    ; __append("\"></i>")
    ; 
}

    ; __line = 31
    ; __append("</div>")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/office/projectTermJobs/tableFields/employee.ejs

}